import "./App.css";
import NavBar from "./NavBar/NavBar";
import Header from "./Header/Header";
import About from "./About/About";
import Title from "./Title/Title";
import Footer from "./Footer/Footer";
import Hobbies from "./Hobbies/Hobbies";
import Experience from "./Experience/Experience";
import AboutNav from "./AboutNav";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Button from "@mui/material/Button";
import { Grid } from "@material-ui/core";
import web from "./socialmedia.PNG";
import Pokemon from "./Pokemon.PNG";
import Hotel from "./Hotel Booking Dashboard.PNG";
function App() {
  return (
    <>
      <section id="home"></section>
      <NavBar></NavBar>
      <AboutNav></AboutNav>
      <About></About>
      <div></div>
      <div className="scroll__margin" id="experience"></div>
      <Experience />
      <section id="projects">
        <center>
          <div className="elegant__title">
            <span style={{ color: "indianred" }}>
              <h3>Projects</h3>
            </span>{" "}
          </div>
        </center>
        <Grid
          container
          spacing={4}
          rowSpacing={3}
          columnSpacing={2}
          direction="row"
          justifyContent="center"
          alignItems="center"
          alignContent="center"
        >
          <Grid item>
            <Card xs={5} sx={{ maxWidth: 800, maxHeight: 600, minHeight: 600 }}>
              <CardMedia
                component="img"
                height="400"
                image="https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1172&q=80"
                sx={{ objectFit: "fill" }}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  <small style={{ fontSize: 16 }}>
                    <b>Nov. 2022</b>
                  </small>{" "}
                  <br></br>
                  Machine Learning Data Analysis using Python to predict House
                  prices
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Performed data wrangling, exploratory data analysis, model
                  development, including simple and multiple linear regression
                  models, and model evaluation and refinement, including
                  polynomial transformations and evaluation of R-squared values,
                  to analyze and predict housing prices using attributes
                  including square footage, number of bedrooms, and other
                  attributes included in an imported dataset for house sales in
                  King County, USA between May 2014, and May 2015. Utilizes the
                  Pandas, NumPy, sci-kit-learn, Matplotlib and seaborn Python
                  libraries, as well as Jupyter Notebook.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item>
            <Card xs={5} sx={{ maxWidth: 800, maxHeight: 600, minHeight: 600 }}>
              <CardMedia
                component="img"
                height="400"
                image={Hotel}
                sx={{ objectFit: "contain" }}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  <small style={{ fontSize: 16 }}>
                    <b>Nov. 2022 </b>
                  </small>{" "}
                  <br></br>
                  Hotel Bookings Data Dashboard using SQL and Microsoft Power BI
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Utilized Microsoft SQL Server Management Studio along with SQL
                  and Microsoft Power BI to analyze and visualize over 100
                  thousand rows of hotel booking data in Microsoft Power BI in
                  order to create a data dashboard that answers common
                  stakeholder questions relating to revenue growth and trends in
                  data.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item>
            <Card xs={5} sx={{ maxWidth: 800, maxHeight: 600, minHeight: 600 }}>
              <CardMedia
                component="img"
                height="400"
                image={web}
                sx={{ objectFit: "contain" }}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  <small style={{ fontSize: 16 }}>
                    <b>Feb. 2022</b> |{" "}
                    <b>
                      {" "}
                      <a href="https://github.com/KarimDarrag/memories-app">
                        Github repository link
                      </a>
                    </b>
                  </small>{" "}
                  <br></br>
                  Social Media Website using the MERN stack
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Using the MERN stack, which includes MongoDB, Express.js,
                  React.js, and Node.js, along with Google OAuth and JSON web
                  tokens for authentication, this project allows users to
                  register, then login either through the website or through
                  Google to create memories that show instantly with a name,
                  title, message, picture, and tags, and have the option to like
                  the memories that they and others post as well. <br></br>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item>
            <Card xs={5} sx={{ maxWidth: 800, maxHeight: 600, minHeight: 600 }}>
              <CardMedia
                component="img"
                height="400"
                image={Pokemon}
                alt="green iguana"
                sx={{ objectFit: "contain" }}
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  <small style={{ fontSize: 16 }}>
                    <b>Sep. 2021 - Oct. 2021</b>|{" "}
                    <b>
                      {" "}
                      <a href="https://github.com/KarimDarrag/pokemon-battle-system-controllers-and-models">
                        Github repository link
                      </a>
                    </b>
                  </small>{" "}
                  <br></br>
                  Pokémon Battle Simulator Browser Game using Laravel
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Developed a locally hosted video game battle simulator based
                  on the popular Pokémon series using Laravel. It is a
                  browser-based game tested with a preset of characters from
                  Pokémon that can battle each other and level up. This project
                  utilized the PHP framework, Laravel, as well as HTML, CSS, and
                  SQLite.<br></br> <br></br>
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </section>
      <br></br>
      <section id="footer">
        <Footer></Footer>
      </section>
    </>
  );
}

export default App;
